import { TemplateType } from 'constants/templateTypes';
import { useTemplateContext } from 'modules/campaigns/editor/context';
import { WhatsAppPrimaryContent } from 'modules/campaigns/editor/types';
import { GRAPHQL_TYPENAMES, GraphQLWhatsAppHeader, ImageHeader, TextHeader } from 'modules/graphql';
import { match } from 'ts-pattern';
import { WebLink2 } from 'ui/theme/typography';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { CommaSeparatedList, CommaSeparatedListItem, LightText } from '../Sections.styled';

const getHeaderContent = (header: GraphQLWhatsAppHeader) =>
  match(header)
    .with({ __typename: GRAPHQL_TYPENAMES.IMAGE_HEADER }, () => (header as ImageHeader).mediaUrl)
    .with({ __typename: GRAPHQL_TYPENAMES.TEXT_HEADER }, () => (header as TextHeader).text)
    .otherwise(() => '');

export const WhatsAppContent = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent = {}, templateType } = templateAndContent;
  const { message, header, footer, buttons } = primaryContent as WhatsAppPrimaryContent;

  const isBusinessInitiated = templateType === TemplateType.BusinessInitiated;
  const headerContent = getHeaderContent(header as GraphQLWhatsAppHeader);

  return (
    <>
      {/* Header */}
      <CampaignFormField labelText="Header">
        <ReadOnlyField name="header">
          {headerContent || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>

      {/* Message */}
      <CampaignFormField labelText="Message">
        <ReadOnlyField name="message">{message || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>

      {/* Business-initiated only */}

      {isBusinessInitiated && (
        <>
          {/* Footer */}
          <CampaignFormField labelText="Footer">
            <ReadOnlyField name="footer">{footer || <LightText>Not set</LightText>}</ReadOnlyField>
          </CampaignFormField>

          {/* Buttons */}
          <CampaignFormField labelText="Buttons">
            <ReadOnlyField name="buttons">
              {buttons?.length ? (
                <CommaSeparatedList>
                  {buttons.map((button, i) => (
                    <CommaSeparatedListItem key={i}>
                      {button.__typename === GRAPHQL_TYPENAMES.URL_BUTTON ? (
                        <WebLink2 href={button?.url}>{button.buttonText}</WebLink2>
                      ) : (
                        button.buttonText || ''
                      )}
                    </CommaSeparatedListItem>
                  ))}
                </CommaSeparatedList>
              ) : (
                <LightText>Not set</LightText>
              )}
            </ReadOnlyField>
          </CampaignFormField>
        </>
      )}
    </>
  );
};
